import { Routes } from '@angular/router';
import { ShareAppComponent } from './Features/share-app/share-app.component';

export const routes: Routes = [
  { path: '', component: ShareAppComponent },
  {
    path: 'reciters/:reciterId',
    pathMatch: 'full',
    loadComponent: () =>
      import('./Features/pages/share-redirect/share-redirect.component').then(
        (mod) => mod.ShareRedirectComponent
      ),
  },
  {
    path: 'reciters/:reciterId/:reciterSlug',
    pathMatch: 'full',
    loadComponent: () =>
      import('./Features/pages/profile/profile.component').then(
        (mod) => mod.ProfileComponent
      ),
  },
  {
    path: 'join/:maqraaToken',
    pathMatch: 'full',
    loadComponent: () =>
      import('./Features/pages/share-redirect/share-redirect.component').then(
        (mod) => mod.ShareRedirectComponent
      ),
  },
  {
    path: 'join/:maqraaToken/:maqraaSlug',
    pathMatch: 'full',
    loadComponent: () =>
      import('./Features/pages/maqraa/maqraa.component').then(
        (mod) => mod.MaqraaComponent
      ),
  },
  {
    path: 'maqraa/:maqraaId',
    pathMatch: 'full',
    loadComponent: () =>
      import('./Features/pages/share-redirect/share-redirect.component').then(
        (mod) => mod.ShareRedirectComponent
      ),
  },
  {
    path: 'maqraa/:maqraaId/:maqraaSlug',
    pathMatch: 'full',
    loadComponent: () =>
      import('./Features/pages/maqraa/maqraa.component').then(
        (mod) => mod.MaqraaComponent
      ),
  },
  {
    path: 'courses/:courseId',
    pathMatch: 'full',
    loadComponent: () =>
      import('./Features/pages/share-redirect/share-redirect.component').then(
        (mod) => mod.ShareRedirectComponent
      ),
  },
  {
    path: 'courses/:courseId/:courseSlug',
    pathMatch: 'full',
    loadComponent: () =>
      import('./Features/pages/course/course.component').then(
        (mod) => mod.CourseComponent
      ),
  },
  {
    path: ':category/:token',
    loadComponent: () =>
      import('./Features/share-app/share-app.component').then(
        (mod) => mod.ShareAppComponent
      ),
  },
];
